export function getBusinessTravellerSelectEnabled(businessAccount?: App.BusinessTraveller.CurrentBusinessAccount): boolean {
  return (
    businessAccount?.employee?.roles?.some(role => ['BUSINESS_ADMIN', 'BUSINESS_MANAGER'].includes(role))) ?? false
}
